// Player names and game codes (spec §57–§59). Shared so the client validates
// exactly as the server does.

export const PLAYER_NAME_MAX_LENGTH = 20;
export const GAME_CODE_LENGTH = 6;

/** Display form: Unicode-normalized, trimmed, internal whitespace collapsed. */
export function cleanPlayerName(raw: string): string {
  return raw.normalize('NFKC').trim().replace(/\s+/g, ' ');
}

/** Identity form: two names that normalize equal are the same seat. */
export function normalizePlayerName(raw: string): string {
  return cleanPlayerName(raw).toLocaleLowerCase('en-CA');
}

/** Returns an error message, or null if the name is acceptable. */
export function validatePlayerName(raw: string): string | null {
  const name = cleanPlayerName(raw);
  if (name.length === 0) return 'Enter a name';
  if ([...name].length > PLAYER_NAME_MAX_LENGTH) return `Names can be at most ${PLAYER_NAME_MAX_LENGTH} characters`;
  if (/\p{C}/u.test(name)) return 'Names cannot contain control characters';
  return null;
}

export function isValidGameCode(code: string): boolean {
  return /^[1-9]\d{5}$/.test(code);
}
